import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Editicon,
  Deleteicon,
  Viewicon,
} from "../../../../Components/IconComponents";
import Table from "../../../../Components/UiComponents/Table/Table";
import { useTranslation } from "react-i18next";
//import { Modal, Button } from "react-bootstrap";
import {
  contactTableData,
  contactcolumnsForExport,
} from "../../../../JsonData/ContactConfig";
import { getContacts, deleteContactURL } from "../../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { getData, putDataWithBody } from "../../../../Services/Services";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import Loader from "react-spinner-loader";
import { RoleContext } from "../../../..";

const ContactTable = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const qs = require("qs");
  const [contactData, setContactData] = useState(contactTableData);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  let contactRegionMap = {};
  useEffect(() => {
    getContactList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const addNewHandler = () => {
    navigate("/planning/create-contact");
  };
  const getSanitizedContactList = (contactList) => {
    let contactListUnique = [];
    let contactListTempMap = [];

    contactList.forEach(function (contact) {
      if (
        !(
          contactListTempMap.indexOf(contact["type"] + "_" + contact["id"]) > -1
        )
      ) {
        contactListUnique.push(contact);
      }
      contactListTempMap.push(contact["type"] + "_" + contact["id"]);
      if (contact["region_name"]) {
        if (contactRegionMap[contact["type"] + "_" + contact["id"]]) {
          let regionArr =
            contactRegionMap[contact["type"] + "_" + contact["id"]];
          regionArr.push(contact["region_name"]);
        } else {
          contactRegionMap[contact["type"] + "_" + contact["id"]] = [
            contact["region_name"],
          ];
        }
      }
    });
    return contactListUnique;
  };
  const getContactList = async () => {
    setLoader(true);
    var contactList = await getData(getContacts);

    contactList = getSanitizedContactList(contactList);

    setLoader(false);
    setContactData(contactList);
    setRowCount(contactList.length);
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = contactcolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  // Helper function to check if a value is empty, null, or undefined
  const isEmptyValue = (value) => {
    return value === null || value === undefined || value === "" || (typeof value === 'string' && value.trim() === "");
  };

  // Helper function to display truncated text with tooltip
  const getTruncatedText = (value, maxLength = 15) => {
    if (isEmptyValue(value)) {
      return "NA";
    }
    
    const text = String(value);
    if (text.length > maxLength) {
      const truncated = text.substring(0, maxLength) + "...";
      return <span title={text}>{truncated}</span>;
    }
    return <span title={text}>{text}</span>;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("contacttableHeaders.name"),
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: t("contacttableHeaders.jobtitle"),
        accessor: "job_title",
        disableSortBy: true,
        Cell: (props) => {
          return getTruncatedText(props.value, 20);
        },
      },

      {
        Header: t("contacttableHeaders.phone1"),
        accessor: "phone1",
        disableSortBy: true,
      },
      {
        Header: t("contacttableHeaders.email"),
        accessor: "email",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            let emailText = props.value;
            if (props.value.length > 20) {
              emailText = props.value.substring(0, 20) + "...";
            }
            return <span title={props.value}>{emailText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      // {
      //   Header: t("contacttableHeaders.address"),
      //   accessor: "address",
      //   Cell: (props) => {
      //     if (props.value) {
      //       let text = props.value;
      //       if (text == "") {
      //         return "NA";
      //       } else {
      //         if (props.value.length > 15) {
      //           text = props.value.substring(0, 15) + "...";
      //         }
      //         return <span title={props.value}>{text}</span>;
      //       }
      //     } else {
      //       return "NA";
      //     }
      //   },
      //   disableSortBy: true,
      // },
      {
        Header: t("contacttableHeaders.region"),
        accessor: "region_name",
        Cell: (props) => {
          if (props.value) {
            let idVal = props.row.original.type + "_" + props.row.original.id;
            if (contactRegionMap[idVal]) {
              let text = contactRegionMap[idVal].join(",");
              if (text.length > 15) {
                text = text.substring(0, 15) + "...";
                return (
                  <span title={contactRegionMap[idVal].join(",")}>{text}</span>
                );
              } else {
                return (
                  <span title={contactRegionMap[idVal].join(",")}>
                    {contactRegionMap[idVal].join(",")}
                  </span>
                );
              }
            } else {
              return "NA";
            }
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("contacttableHeaders.agencyname"),
        accessor: "agency_name",
        Cell: (props) => {
          if (props.value) {
            let text = props.value;
            if (props.value.length > 15) {
              text = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{text}</span>;
          } else {
            return "NA";
          }
        },

        disableSortBy: true,
      },

      {
        Header: t("contacttableHeaders.type"),
        accessor: "type",
        disableSortBy: true,
      },
      {
        Header: t("contacttableHeaders.skill"),
        accessor: "skills",
        Cell: (props) => {
          if (props.value) {
            let text = props.value;
            if (props.value.length > 15) {
              text = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{text}</span>;
          } else {
            return "NA";
          }
        },

        disableSortBy: true,
      },

      // {
      //   Header: "Contact Type",
      //   accessor: "type",
      //   disableSortBy: true,
      // },
      // {
      //   Header: "Status  ",
      //   accessor: "status",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     return <StatusHandler props={props} />;
      //   },
      // },
      {
        Header: t("contacttableHeaders.quantity"),
        accessor: "quantity",
        Cell: (props) => {
          // Handle quantity display: show 0 if value is 0, show NA if null/undefined
          if (props.value === null || props.value === undefined) {
            return "NA";
          } else {
            return props.value;
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("contacttableHeaders.action"),
        disableSortBy: true,
        disableFilters: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteContactURL, data, {});
            if (res.status == "success") {
              getContactList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };
          return (
            <div className="usertable__actionsicon">
              <span
                onClick={() =>
                  navigate("/planning/create-contact", {
                    state: {
                      data: props.row.original,
                      edit: true
                    },
                  })
                }>
                {props.row.original.type == "external" && (
                  <Editicon
                    value={props.value}
                    className="cursor-pointer me-2"
                  />
                )}
              </span>
              {props.row.original.type == "external" && roleName === process.env.REACT_APP_SUPER_ADMIN && (
                <span onClick={deletePopUp}>
                  <Deleteicon
                    value={props.value}
                    className="cursor-pointer mr-1"
                  />
                </span>
              )}
              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  //   data={data}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.name}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, roleName]
  );
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="datatable__container">
        {contactTableData && (
          <Table
            data={contactData}
            columns={columns}
            numberOfRows={10}
            setSearchData={setSearchData}
            addButtonLabel={t("contactaddButtonLabel")}
            addNewHandler={addNewHandler}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={rowCount} // Pass rowCount to the Table component
            enableColumnFilters={true}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
      </div>
    </div>
  );
});

export default ContactTable;
